<template>
  <b-row
    align-h="between"
    align-v="center"
    class="group-booking-container no-gutters"
  >
    <b-col lg="8" md="12">
      <h2 class="group-booking-heading">{{ strings.groupBookingHeading }}</h2>
      <span class="group-booking-description">
        {{ strings.groupBookingDescription }}
      </span>
    </b-col>
    <b-col lg="4" md="12" class="text-align-right">
      <button
        :class="ctaClass"
        class="group-booking-cta-link"
        @click="redirectToGroupCheckoutPage"
      >
        {{ strings.bookForAGroup }}
      </button>
    </b-col>
  </b-row>
</template>

<script>
import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

export default {
  props: ["ctaClass"],
  computed: {
    strings() {
      return this.$store.state.strings;
    },
  },
  methods: {
    redirectToGroupCheckoutPage() {
      let lang = this.$store.state.selectedLang;
      
      if(lang == 'en'){
        lang = '';
      } else {
        lang = '/' + lang;
      }
      
      let url = `${lang}/group-event-booking?venueId=${this.$store.state.venueInfo.id}`

      if (window.mp_url_settings?.BASE_URL && window.mp_url_settings?.BASE_URL !== '') {
        url = `${window.mp_url_settings?.BASE_URL}/group-event-booking?venueId=${this.$store.state.venueInfo.id}`
      }

      window.location.assign(url);
    },
  },
};
</script>
<style>
.group-booking-container {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
}

.group-booking-heading {
  margin-top: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #16181b;
  line-height: 1.25;
  margin-bottom: 4px;
}

.group-booking-description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #475569;
}

.text-align-right {
  text-align: right;
}

.group-booking-cta-link {
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 100px;
  background: #0050ff;
  margin-bottom: 0px !important;
  text-decoration: none !important;
}

.group-booking-cta-link:visited {
  color: #ffffff !important;
}

@media (max-width: 970px) {
  .group-booking-cta-link {
    width: 100%;
    margin-top: 16px;
  }
}

.no-gutters {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
</style>
